const BACKEND = "https://art4n.rmtcfg.com";

export const getAvailableTokens = () =>
  fetch(`${BACKEND}/available`).then((response) => response.json());
